import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { API } from "@/lib/api";
import { Link } from "react-router-dom";
import { Download, Lock, ClipboardCheck, ArrowRight } from "lucide-react";

export const fileUrl = (id, download = false) => `${API}/textbooks/${id}/file${download ? "?download=true" : ""}`;

const QuizStrip = ({ quizzes }) => (
  <div className="px-5 py-2.5 border-b border-slate-200 bg-amber-50/60 flex flex-wrap items-center gap-2" data-testid="pdf-viewer-quizzes">
    <span className="text-xs font-semibold text-amber-800 inline-flex items-center gap-1 mr-1">
      <ClipboardCheck className="w-4 h-4" /> Test yourself
    </span>
    {quizzes.map((q) => (
      <Link key={q.id} to={`/exam/${q.id}`} className="text-xs font-medium bg-white border border-amber-200 hover:border-amber-400 text-slate-800 rounded-full px-3 py-1.5 inline-flex items-center gap-1.5 transition-colors" data-testid={`pdf-viewer-quiz-${q.id}`}>
        {q.title} <span className="text-slate-400">· {q.question_count} Q</span> <ArrowRight className="w-3 h-3" />
      </Link>
    ))}
  </div>
);

export const PdfViewer = ({ book, onClose, canDownload, showQuizzes = false }) => (
  <Dialog open={!!book} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-6xl w-[95vw] h-[90vh] flex flex-col p-0 gap-0" data-testid="pdf-viewer-dialog">
      {book && (
        <>
          <DialogHeader className="px-5 py-3 border-b border-slate-200 flex-row items-center justify-between space-y-0 pr-12">
            <div className="min-w-0">
              <DialogTitle className="font-display truncate" data-testid="pdf-viewer-title">{book.title}</DialogTitle>
              <DialogDescription className="text-xs">
                {book.board} · {book.grade_level ? `Class ${book.grade_level} · ` : ""}{book.subject}
                {book.chapter_number != null ? ` · Chapter ${book.chapter_number}` : ""}
              </DialogDescription>
            </div>
            {canDownload ? (
              <a href={fileUrl(book.id, true)} className="btn-primary text-sm shrink-0" data-testid="pdf-viewer-download-btn">
                <Download className="w-4 h-4" /> Download
              </a>
            ) : (
              <span className="text-xs text-slate-500 inline-flex items-center gap-1 shrink-0" data-testid="pdf-viewer-download-disabled">
                <Lock className="w-3.5 h-3.5" /> View only
              </span>
            )}
          </DialogHeader>
          {showQuizzes && book.quizzes?.length > 0 && <QuizStrip quizzes={book.quizzes} />}
          <iframe
            title={book.title}
            src={`${fileUrl(book.id)}${canDownload ? "" : "#toolbar=0"}`}
            className="flex-1 w-full bg-slate-100 rounded-b-lg"
            data-testid="pdf-viewer-frame"
          />
        </>
      )}
    </DialogContent>
  </Dialog>
);
